import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { LectureId } from '../../curriculum/types/lecture-interface'
import { getLightCourseGetLecturePath } from '../light-course-api'
import { LightCourseLectureInterface } from '../light-course-interface'

export const useLightCourseLecture = (lectureId?: LectureId) => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, LightCourseLectureInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate } = useControlledSwr(() => {
    if (!lectureId) return null
    return [
      getLightCourseGetLecturePath(lectureId),
      RequestModuleEnum.MembershipLightCourse,
      RequestModuleEnum.MembershipCourseLecture,
    ]
  }, fetcher)

  return {
    lecture: data,
    mutate,
  }
}
